import ProjectSharePublicPage from "@/pages/ProjectSharePublicPage";
import ClarityOneLoginPage from "@/pages/clarity-one/ClarityOneLoginPage";
import ClarityOneAuthVerifyPage from "@/pages/clarity-one/ClarityOneAuthVerifyPage";
import ClarityOneAuthImpersonatePage from "@/pages/clarity-one/ClarityOneAuthImpersonatePage";
import ClarityOneHomePage from "@/pages/clarity-one/ClarityOneHomePage";
import ClarityOneRootPage from "@/pages/clarity-one/ClarityOneRootPage";
import ClarityOneNotFoundPage from "@/pages/clarity-one/ClarityOneNotFoundPage";
import KaleidescapeWalletPage from "@/pages/clarity-one/KaleidescapeWalletPage";
import ClarityOneMyAccountPage from "@/pages/clarity-one/ClarityOneMyAccountPage";
import ClarityOneStatementPage from "@/pages/clarity-one/ClarityOneStatementPage";
import ClarityOneServicePage from "@/pages/clarity-one/ClarityOneServicePage";
import ClarityOneWarrantyPage from "@/pages/clarity-one/ClarityOneWarrantyPage";
import ClarityOneProposalsPage from "@/pages/clarity-one/ClarityOneProposalsPage";
import ClarityOneDocumentsPage from "@/pages/clarity-one/ClarityOneDocumentsPage";
import ClarityOneInvoicesPage from "@/pages/clarity-one/ClarityOneInvoicesPage";
import ClarityOneDeliveriesPage from "@/pages/clarity-one/ClarityOneDeliveriesPage";
import ProposalPublicPage from "@/pages/ProposalPublicPage";
import VariationOrderPublicPage from "@/pages/VariationOrderPublicPage";
import PortalInvoicePage from "@/pages/PortalInvoicePage";
import DealInvoicePage from "@/pages/DealInvoicePage";
import { Route, Switch } from "wouter";

/**
 * SPA routes for one.claritygroup.com.sg (production) and localhost Clarity One dev paths.
 * Staff portal routes are never registered here.
 */
export default function ClarityOneDomainRouter() {
  return (
    <Switch>
      <Route path="/login" component={ClarityOneLoginPage} />
      <Route path="/auth/verify/:token" component={ClarityOneAuthVerifyPage} />
      <Route path="/auth/impersonate/:token" component={ClarityOneAuthImpersonatePage} />
      <Route path="/wallet/kaleidescape" component={KaleidescapeWalletPage} />
      <Route path="/account/statement" component={ClarityOneStatementPage} />
      <Route path="/service" component={ClarityOneServicePage} />
      <Route path="/warranty" component={ClarityOneWarrantyPage} />
      <Route path="/account" component={ClarityOneMyAccountPage} />
      <Route path="/proposals/:proposalId" component={ProposalPublicPage} />
      <Route path="/proposals" component={ClarityOneProposalsPage} />
      <Route path="/documents" component={ClarityOneDocumentsPage} />
      <Route path="/invoices/portal/:token" component={PortalInvoicePage} />
      <Route path="/invoices/deal/:token" component={DealInvoicePage} />
      <Route path="/invoices" component={ClarityOneInvoicesPage} />
      <Route path="/deliveries" component={ClarityOneDeliveriesPage} />
      <Route path="/vo/:token" component={VariationOrderPublicPage} />
      <Route path="/home" component={ClarityOneHomePage} />
      <Route path="/share/:token" component={ProjectSharePublicPage} />
      <Route path="/" component={ClarityOneRootPage} />
      <Route component={ClarityOneNotFoundPage} />
    </Switch>
  );
}
